import React from 'react';
import "../css/status-cell.css";

const StatusCellRenderer = ({data: {statusRender}}) => {

    return (
        <div className={statusRender?.class}>
            {statusRender?.text}
        </div>
    );
};

export default StatusCellRenderer;